import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ConfigSlice = {
  apiBaseUrl: string;
  authBaseUrl: string;
  oAuth2ClientId: string;
  oAuth2RedirectUri: string;
};

const initialState: ConfigSlice = {
  apiBaseUrl: '',
  authBaseUrl: '',
  oAuth2ClientId: '',
  oAuth2RedirectUri: ''
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig: (state, action: PayloadAction<ConfigSlice>) => {
      const { apiBaseUrl, authBaseUrl, oAuth2ClientId, oAuth2RedirectUri } = action.payload;
      state.apiBaseUrl = apiBaseUrl;
      state.authBaseUrl = authBaseUrl;
      state.oAuth2ClientId = oAuth2ClientId;
      state.oAuth2RedirectUri = oAuth2RedirectUri;
    }
  }
});

export const { setConfig } = configSlice.actions;
